// src/components/Projects.js
import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const ProjectsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: ${props => props.theme.spacing.xl};
  padding: ${props => props.theme.spacing.xxl};
  max-width: 1200px;
  margin: 0 auto;
`;

const ProjectCard = styled(motion.div)`
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }
`;

const ProjectImage = styled.div`
  height: 200px;
  background: ${props => props.bgColor || props.theme.colors.primary};
  position: relative;
  overflow: hidden;
`;

const ProjectInfo = styled.div`
  padding: ${props => props.theme.spacing.lg};
`;

const ProjectTitle = styled.h3`
  margin: 0;
  color: ${props => props.theme.colors.text};
  font-size: 20px;
`;

const ProjectDescription = styled.p`
  color: ${props => props.theme.colors.lightText};
  margin: ${props => props.theme.spacing.md} 0;
`;

const projects = [
  {
    id: 1,
    title: "Project 1",
    description: "A brief description of project 1",
    color: "#0066FF",
    tags: ["React", "Node.js"]
  },
  // Add more projects
];

function Projects() {
  return (
    <ProjectsGrid>
      {projects.map((project) => (
        <Link 
          to={`/project/${project.id}`} 
          key={project.id}
          style={{ textDecoration: 'none' }}
        >
          <ProjectCard
            whileHover={{ y: -5 }}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
          >
            <ProjectImage bgColor={project.color} />
            <ProjectInfo>
              <ProjectTitle>{project.title}</ProjectTitle>
              <ProjectDescription>{project.description}</ProjectDescription>
            </ProjectInfo>
          </ProjectCard>
        </Link>
      ))}
    </ProjectsGrid>
  );
}

export default Projects;